export default __webpack_public_path__ + "static/media/cult.28f415ab.jpg_medium";